module.exports = __webpack_public_path__ + "img/0130.c5a7148f.jpg";